
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll(".ProductItem__ColorSwatchItem").forEach( function(colorSwatch){
     
    var defaultHoverImage = colorSwatch.closest(".ProductItem__Wrapper").querySelector(".ProductItem__Image.ProductItem__Image--alternate").getAttribute("data-src");
     colorSwatch.addEventListener( 'mouseenter', function() {
        var swatchImage = this.querySelector(".ColorSwatch__Radio").getAttribute("data-image-url");
        if(swatchImage != null){
          var ProductItem = this.closest(".ProductItem__Wrapper").querySelector(".ProductItem__Image.ProductItem__Image--alternate");
          ProductItem.setAttribute("data-src",swatchImage);
          ProductItem.setAttribute("src",swatchImage);
        }
      });
     colorSwatch.addEventListener('mouseleave', function() {
        var ProductItem = this.closest(".ProductItem__Wrapper").querySelector(".ProductItem__Image.ProductItem__Image--alternate");
         ProductItem.setAttribute("data-src",defaultHoverImage);
          ProductItem.setAttribute("src",defaultHoverImage);
     });

    colorSwatch.addEventListener( 'click', function() {
      document.querySelectorAll(".ProductItem__ColorSwatchItem").forEach(function(colorSwatch){
        colorSwatch.querySelector("input").removeAttribute("checked");
      });
      
      // var input = colorSwatch.querySelector("input");
      // input.setAttribute("checked",checked);
      var productItem = this.closest(".ProductItem");
      var swatchRadio =  this.querySelector(".ColorSwatch__Radio");
      var variantUrl = swatchRadio.getAttribute("data-variant-url");

      productItem.querySelector('.ProductItem__ImageWrapper').setAttribute('href', variantUrl);
      productItem.querySelector('.ProductItem__Title > a').setAttribute('href', variantUrl);
      var originalImageElement = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
      
        if (swatchRadio.hasAttribute('data-image-url') && swatchRadio.getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {
          var newImageElement = document.createElement('img');
          newImageElement.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad';
          newImageElement.setAttribute('data-image-id', swatchRadio.getAttribute('data-image-id'));
          newImageElement.setAttribute('data-src', swatchRadio.getAttribute('data-image-url'));
          newImageElement.setAttribute('data-widths', swatchRadio.getAttribute('data-image-widths'));
          newImageElement.setAttribute('data-sizes', 'auto');

          // Replace the original node
          if (window.theme.productImageSize === 'natural') {
            originalImageElement.parentNode.style.paddingBottom = 100.0 / swatchRadio.getAttribute('data-image-aspect-ratio') + '%';
          }

          originalImageElement.parentNode.style.setProperty('--aspect-ratio', swatchRadio.getAttribute('data-image-aspect-ratio'));
          originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
        }
    });
  });
});
// Fuilter tab in mobile
document.addEventListener('DOMContentLoaded', function() {
    var filterTitles = document.querySelectorAll('.mb-filter-values .mb-filter_title');
    //console.log("filterTitles",filterTitles)
  
    filterTitles.forEach(function(filterTitle) {
        filterTitle.addEventListener('click', function() {
            // Remove the 'active' class from all titles and filter groups
            filterTitles.forEach(function(t) {
                t.classList.remove('active');
            });
            this.classList.add('active');
            var filterValue = filterTitle.getAttribute("data-value");
            console.log("filterValue",filterValue);

            document.querySelectorAll('.filter-group').forEach(function(group) {
              group.classList.remove('active');
               var filterGroup = group.getAttribute("data-value");
                if (filterValue == filterGroup){
                  group.classList.add('active');
                }
            });
        });
    });
});



// on collections page if filter any filter value selected then display products_list
  var checkboxes = document.querySelectorAll('.filter');
    var collectionList = document.querySelector('.CollectionList-main');
    var productList = document.querySelector('.product_list_main');
    // console.log("collectionList",collectionList);
    function updateCollectionVisibility() {
        var selectedLabels = document.querySelectorAll('.selected');
        if (selectedLabels.length > 0) {
            collectionList.classList.add('hidden');
            productList.classList.remove('hidden');
        } else {
            collectionList.classList.remove('hidden');
            productList.classList.add('hidden');
        }
    }

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
            updateCollectionVisibility();
        });
    });

    // Function to handle checkbox click event
    function handleCheckboxClick() {
    // Get all checkboxes with class 'filter'
    var checkboxes = document.querySelectorAll('.filter');
    
    // Get all product items
    var productItems = document.querySelectorAll('.product-list_conatiner .ProductItem');

    checkboxes.forEach(function(checkbox) {
        checkbox.addEventListener('click', function() {
          
            // Array to store selected color values
            var selectedValues = [];
            var selectedCategories = [];
            var selectedData = [];
            // console.log("selectedCategories",selectedCategories);
            // Iterate over each checked checkbox
            checkboxes.forEach(function(checkbox) {
                if (checkbox.checked) {
                       console.log(checkbox.getAttribute('data-value'));
                    selectedValues.push(checkbox.getAttribute('data-value'));
                }
              //
            });
           console.log("selectedValues",selectedValues);
          var cnt = 0
            // Iterate over each product item
          var arr = [];
            productItems.forEach(function(item) {
                var colourValue = item.getAttribute('data-colour');
                var categoryValue = item.getAttribute('data-category');
                var forHumansValue = item.getAttribute('data-for-humans');
                var breedsValue = item.getAttribute("data-size");
              
                var colors = colourValue.split(',');
                var sizes = breedsValue.split(',');
              
                // Check if all selected colors exist in the product item's colors
                var allSelectedColors = selectedValues.some(function(color) {
                    return colors.includes(color);
                });
                //console.log("allSelectedColors",allSelectedColors);
              
                var allSizesColors = selectedValues.some(function(size) {
                  return sizes.includes(size);
                });
                // Check if the categoryValue matches any selected category
                var categoryMatched = selectedValues.includes(categoryValue);
                var forHumansMatched = selectedValues.includes(forHumansValue);
                // var breedsmatched = selectedValues.includes(breedsValue);
              
                // If all selected colors are present and the category matches, remove 'hidden' class
                if (allSelectedColors || categoryMatched || forHumansMatched || allSizesColors) {
                    item.parentElement.classList.remove('hidden');
                } else {
                    // Otherwise, add 'hidden' class
                    item.parentElement.classList.add('hidden');
                }
            });
        });
    });
}

// Call the function to handle checkbox click event
handleCheckboxClick();


$(document).ready(function(){
  $('.blog-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: true,
    appendDots: '.slideshow__controls',
    nextArrow: '.slideshow__arrow-left',
    prevArrow: '.slideshow__arrow-right',
    asNavFor: '.blog-nav'
  });



  $('.blog-nav').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.blog-slider',
    dots: false,
    focusOnSelect: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });


  $('.Testimoniallist').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 3000,
    asNavFor: '.TestimonialNavs',
    responsive: [
      {
        breakpoint: 640,
        settings: {
          dots: true,
        }
      }
    ]

  });
  $('.TestimonialNavs').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.Testimoniallist',
    dots: false,
    focusOnSelect: true
  });

  function imgClick() {
    jQuery('.ImageHero__ContentOverlay').hide();  //hide image to play the video
    var ifrm = document.getElementById("play_video");
    var src =$('#play_video').attr('src'); 
    ifrm.setAttribute("src", src+'?autoplay=1&loop=1');
    // add rest of your values
    ifrm.frameborder = 0;
    return false;
  }
  $(".Video__PlayButton").click(function(){
    imgClick();
    $('#play_video').css('display','block');  
    $('#play_video').trigger('play'); 
  });

  var ua = navigator.userAgent || navigator.vendor || window.opera;
  var isInstagram = (ua.indexOf('Instagram') > -1) ? true : false;
  if (document.documentElement.classList ){
    if (isInstagram) {
      window.document.body.classList.add('instagram-browser');
      // alert("debugging within the Instagram in-app browser");
    }
  }  

  if($("html").hasClass("FAQs")){
    if(window.location.hash && window.location.hash.substr(1) == "return_policy") {
      $('html, body').animate({
        scrollTop: $("#return_policy").offset().top - ($("#section-header").outerHeight() +  20)
      }, 2000);
    }
  }
  
  
  
  if( $('.product_engraving').length > 0 ){    

    // OLD CODE
    //     $('.ProductForm__Variants .ProductForm__Option').hide();
    //     $('.eng_details').slideUp();
    //     $('input[type=radio][name=eng_option]').change(function() {
    //       console.log('clicked');
    //       if (this.value == 'no') {
    //         $('[name="properties[eng_name]"]').val('');
    //         $('[name="properties[eng_secondline]"]').val('');
    //         $('.eng_details').slideUp();
    //         $('.SizeSwatchList').find('[data-handle="Tag d’identité | Name Tag"]').find('input').trigger('click');    //       }
    //       else if (this.value == 'yes') {
    //         console.log('aa',$(this).closest('.Product__InfoWrapper').find('.hulkapps_submit_cart').length);
    //         $(this).closest('.Product__InfoWrapper').find('.hulkapps_submit_cart').css({'display':'none'});
    //         $('.eng_details').slideDown();
    //         $('.SizeSwatchList').find('[data-handle="Tag d’identité | Name Tag engraving"]').find('input').trigger('click');
    //         $("#eng_name").focusout(function(){
    //           var $this = $(this);
    //           if($this.val() == ''){            
    //             $(this).css({'border-color':'red','background-color': '#fff0f0'});
    //             $(this).focus();
    //           } else {
    //             $(this).css({'border-color':'black','background-color': '#fff'});
    //             $('.ProductForm__AddToCart').css({'pointer-events':'all'});
    //           }
    //         });
    //       }
    //     });    
    // OLD CODE

    // setTimeout(function(){
    //   if( $('.hulkapps_option_set').length > 0 ){
    //     //console.log('here');

    //     $('.ProductForm__Variants .ProductForm__Option').hide();
    //     $('.eng_details').slideUp();
    //     $('.hulkapps_option_set').find('.hulkapps_radio_option').find('input[type="radio"][data-conditional-value="No"]').trigger('click');
		
    //     $('.hulkapps_radio_option input[data-price="20.00"] + .radio_div').text('Yes (+$20.00)');
        
    //     $('.hulkapps_radio_option input[type=radio]').change(function() {
    //       var $option_val = $(this).data('conditional-value').toLowerCase();
    //       //console.log('clicked==',$option_val);
    //       if ($option_val == 'no') {
    //         $('[name="properties[First Line]"]').val('');
    //         $('[name="properties[Second Line]"]').val('');
    //         $('.eng_details').slideUp();
    //         //$('.SizeSwatchList').find('[data-handle="Tag d’identité | Name Tag"]').find('input').trigger('click');
    //         $('.ProductForm__AddToCart').css({'pointer-events':'all'});
    //       }
    //       else if ($option_val == 'yes') {
    //         $('.eng_details').slideDown();
    //         //$('.SizeSwatchList').find('[data-handle="Tag d’identité | Name Tag engraving"]').find('input').trigger('click');
    //         $('.ProductForm__AddToCart').css({'pointer-events':'none'});

    //         $("#eng_name").focusout(function(){
    //           var $this = $(this);
    //           if($this.val() == ''){
    //             $('.ProductForm__AddToCart').css({'pointer-events':'none'});
    //             $(this).css({'border-color':'red','background-color': '#fff0f0'});
    //             $(this).focus();
    //           } else {
    //             $('.ProductForm__AddToCart').css({'pointer-events':'all'});
    //             $(this).css({'border-color':'black','background-color': '#fff'});
    //           }
    //         });
    //       }

    //     });

    //   }
    // },2000);
    
  } 
  
  /* Related product js */
  $('.ProductRelated .Carousel').flickity({
    cellAlign: 'left',
    prevNextButtons: true,
    pageDots: false,
    wrapAround: false,
    contain: true,
    cellAlign: "center",
    watchCSS: true,
    dragThreshold: 8,
    groupCells: true,
    arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
  });
  
  $('.blog_banner_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    dots: true
  });
  
});

// Animation Class Add/Remove Js
$(document).ready(function() {
  var $animationElements = $('.CollectionItem__Content');
  var $window = $(window);

  function checkIfInView() {

    var windowHeight = $window.height();
    var windowTopPosition = $window.scrollTop();
    var windowBottomPosition = (windowTopPosition + windowHeight);

    $.each($animationElements, function () {
      var $element = $(this);
      var elementHeight = $element.outerHeight();
      var elementTopPosition = $element.offset().top;
      var elementBottomPosition = (elementTopPosition + elementHeight);

      //check to see if this current container is within viewport
      if ((elementBottomPosition >= windowTopPosition) &&
          (elementTopPosition <= windowBottomPosition)) {
        $element.addClass('animate__fadeInUp');
      } else {
        $element.removeClass('animate__fadeInUp');
      }
    });
  }

  $window.on('scroll resize', checkIfInView);
  $window.trigger('scroll');
  
  $('.popup_btn').click(function(){
    $(this).next().css('display','flex');
  });

  $('.close').click(function(){
    $(this).parents('.video_modal').hide();
  });
});

$(document).mouseup(function(e) {
  var container = $(".popup_content");
  if (!container.is(e.target) && container.has(e.target).length === 0) 
  {
    $('.video_modal').hide();
  }
});

// Collections Sectiion Mobile Slider Js
if ($(window).width() < 641) {
  $('.collection_grid').slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    slidesToShow: 1
  });
};

// Blog Category Filter Dropdown Js
$(document).ready(function(){
  $(".mobile_all_cate").click(function(){
    $(this).toggleClass('dropdown_active');
    $(this).nextAll().toggleClass('show');
  });
});
$('.Drawer__Close').click(function(){
$('.SidebarMenu').attr("aria-hidden","true");
  $('.Drawer').attr("aria-hidden","true");
  
});

//MOBILE
$(document).ready(function() {
  $("#tabs").tabs({
    active: 0,
    activate: function(event, ui) {
      // Get the top position of the filter container
      var filterContainerTop = $("#filters-containermb").offset().top;

      // Scroll the window to the top position of the filter container
      $('html, body').animate({scrollTop: filterContainerTop}, 300);
    }
  });

  $('#toggle-filtersmb').on('click', function() {
    let togglefilters = $(this).text();
    if (togglefilters == "FILTER +") {
      $(this).text('FILTER -');
    } else {
      $(this).text('FILTER +');
    }
    $('#filters-contentsmb').toggle();
  });

  function filterProducts() {
    var selectedColors = [];
    $('.color-filters:checked').each(function() {
      selectedColors.push($(this).data('value'));
    });

    var selectedCategories = [];
    $('.category-filters:checked').each(function() {
      $('.CollectionList-main').hide();
      selectedCategories.push($(this).data('value'));
    });

    var selectedObjects = [];
    $('.object-filters:checked').each(function() {
      $('.CollectionList-main').hide();
      selectedObjects.push($(this).data('value'));
    });

    var selectedSizes = [];
    $('.size-filters:checked').each(function() {
      $('.CollectionList-main').hide();
      selectedSizes.push($(this).data('value'));
    });

    $('.product_list_main .product_grid').each(function() {
      var productColors = $(this).data('colour') ? $(this).data('colour').split(',') : [];
      var productCategory = $(this).data('category');
      var productObject = $(this).data('object');
      var productSizes = $(this).data('size') ? $(this).data('size').split(',') : [];

      var colorMatch = selectedColors.length === 0 || selectedColors.some(color => productColors.includes(color));
      var categoryMatch = selectedCategories.length === 0 || selectedCategories.includes(productCategory);
      var objectMatch = selectedObjects.length === 0 || selectedObjects.includes(productObject);
      var sizeMatch = selectedSizes.length === 0 || selectedSizes.some(size => productSizes.includes(size));

      if (colorMatch && categoryMatch && objectMatch && sizeMatch) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  }
$('.color-filters-label, .category-filters-label, .object-filters-label, .size-filters-label').click(function() {
    $(this).toggleClass('selected');
});

  $('.color-filters, .category-filters, .object-filters, .size-filters').on('change', function() {
    $(this).next('label').addClass('selected');
    if ($(this).is(':checked')) {
      $(this).next('label').addClass('selected');
    } else {
      $(this).next('label').removeClass('selected');
    }
    filterProducts();
  });

  $('#done-filtersmb').on('click', function() {
    $('#filters-contentsmb').hide();
  });

  $('#clear-filtersmb').on('click', function() {
    $(".color-wrp, .category-filters-label , .object-filters-label, .size-filters-label").removeClass('boldclass');
    $('.CollectionList-main').show();
    $('.color-filters, .category-filters, .object-filters, .size-filters').prop('checked', false).next('label').removeClass('selected');
    $('.product_list_main .product_grid').hide();
  });
});

//DESKTOP
 $(document).ready(function() {
  $('.product_list_main .product_grid').hide();

  $("#toggle-filters").on('click', function() {
    let togglefilters = $(this).text();
    if(togglefilters== "FILTER +"){
      $(this).text('FILTER -');
    }else{
       $(this).text('FILTER +');
    }
    $('#filters-contents').toggle();
  });

  function filterProducts() {
    var selectedColors = [];
    $('.color-filters:checked').each(function() {
      selectedColors.push($(this).data('value'));
    });

    var selectedCategories = [];
    $('.category-filters:checked').each(function() {
         $('.CollectionList-main').hide();
      selectedCategories.push($(this).data('value'));
    });

    var selectedObjects = [];
    $('.object-filters:checked').each(function() {
         $('.CollectionList-main').hide();
      selectedObjects.push($(this).data('value'));
    });

    var selectedSizes = [];
    $('.size-filters:checked').each(function() {
         $('.CollectionList-main').hide();
      selectedSizes.push($(this).data('value'));
    });

    $('.product_list_main .product_grid').each(function() {
      var productColors = $(this).data('colour') ? $(this).data('colour').split(',') : [];
      var productCategory = $(this).data('category');
      var productObject = $(this).data('object');
      var productSizes = $(this).data('size') ? $(this).data('size').split(',') : [];

      var colorMatch = selectedColors.length === 0 || selectedColors.some(color => productColors.includes(color));
      var categoryMatch = selectedCategories.length === 0 || selectedCategories.includes(productCategory);
      var objectMatch = selectedObjects.length === 0 || selectedObjects.includes(productObject);
      var sizeMatch = selectedSizes.length === 0 || selectedSizes.some(size => productSizes.includes(size));

      if (colorMatch && categoryMatch && objectMatch && sizeMatch) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  }

  $('.color-filters, .category-filters, .object-filters, .size-filters').on('change', function() {
    if ($(this).is(':checked')) {
      $(this).next('label').addClass('selected');
    } else {
      $(this).next('label').removeClass('selected');
    }
    filterProducts();
  });

  $('#done-filters').on('click', function() {
    $('#filters-contents').hide();
  });

  $('#clear-filters').on('click', function() {
       $('.CollectionList-main').show();
    $('.color-filters, .category-filters, .object-filters, .size-filters').prop('checked', false).next('label').removeClass('selected');
    $('.product_list_main .product_grid').hide();
  });
});

